<script lang="ts">
  import { AppState } from '../../etc/stores';

  import Spinner from '../misc/Spinner.svelte';
  import Text from '../typography/Text.svelte';

  export let type: 'button' | 'reset' | 'submit' = 'button';
  export let schema: 'primary' | 'secondary' | 'green' | 'white' = 'primary';
  export let loading = false;
  export let disabled = false;
  export let label: string = '';
</script>

<button
  {type}
  on:click
  disabled={disabled || loading}
  class="twism-button twism-{schema} {$$props.class || ''}"
  class:twism-disabled={disabled}
>
  <div class="twism-button-content">
    {#if loading}
      <Spinner
        color={schema === 'white'
          ? $AppState.theme.colors.typography
          : $AppState.theme.colors.textAboveBackground}
      />
    {:else if label}
      <slot name="left-icon" />
      <Text class="twism-text-button" type="default">{label}</Text>
    {:else}
      <slot />
    {/if}
  </div>
</button>

<style lang="scss">
  $disabled-color: #cfdae5;

  .twism-button {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    text-decoration: none;
    box-sizing: border-box;
    outline: none;
    height: 48px;
    transition: background-color 0.2s ease-in-out;
    position: relative;
    cursor: pointer;

    &-content {
      width: 100%;
      height: 100%;
      pointer-events: none;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 5;
      top: 0;
      left: 0;
      right: 0;
    }

    &.twism-disabled {
      cursor: default;
      pointer-events: none;
    }

    &.twism-primary {
      color: var(--twism-theme-textAboveBackground);
      background: var(--twism-theme-backgroundGradient);
      box-shadow: 0px 17px 32px -14px var(--twism-theme-shadowColor);
      border: none;

      :global(.twism-text-button) {
        color: var(--twism-theme-textAboveBackground) !important;
      }

      &.twism-disabled {
        opacity: 0.3;
        pointer-events: none;
      }

      @media screen and (min-width: 768px) {
        &:before {
          content: '';
          background: var(--twism-theme-backgroundGradientHover);
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          position: absolute;
          transition: opacity 0.2s ease-in-out;
          pointer-events: none;
          opacity: 0;
        }

        &:hover:before {
          opacity: 1;
        }
      }
    }

    &.twism-secondary {
      color: var(--twism-theme-textAboveBackground);
      background-color: $color-white;
      border: 1px solid var(--twism-theme-textLighter);
      :global(.twism-text-button) {
        color: var(--twism-theme-textLighter) !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 24px !important;
      }

      &:hover {
        background-color: darken($color-white, 4%);
      }
    }

    &.twism-green {
      background-color: $color-copy-success;
      color: $color-white;
      box-shadow: 0px 17px 32px -14px var(--twism-theme-shadowColor);
      border: none;

      :global(.twism-text-button) {
        color: $color-white !important;
      }

      &:hover {
        background-color: $color-copy-success;
      }
    }

    &.twism-white {
      background-color: #fff;
      color: var(--twism-theme-typography);
      border: none;

      :global(.twism-text-button) {
        color: var(--twism-theme-typography) !important;
      }

      &:hover {
        background-color: #f5f5f5;
      }
    }

    &.twism-disabled {
      background-color: $disabled-color;
      border-color: $disabled-color;
      :global(p) {
        color: $color-white;
      }
    }
  }

  :global(.twism-text-button) {
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    margin: 0 !important;
  }
</style>
